import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckListSelectItem } from '../../../models/check-list-select-item.model';

@Component({
  selector: 'check-list-select',
  standalone: false,
  templateUrl: './check-list-select.component.html',
  styleUrls: ['./check-list-select.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CheckListSelectComponent,
    },
  ],
})
export class CheckListSelectComponent implements ControlValueAccessor {
  @Input() id: string;
  @Input() items: Array<CheckListSelectItem> = [];

  checkedItems: Array<string> = [];

  onChange: (value: Array<string>) => void;
  onTouched: () => void;
  touched: boolean = false;
  disabled: boolean = false;

  handleItemCheckedValueChange(clickedItemValue: string, event: any): void {
    this.markAsTouched();

    if (this.disabled) {
      return;
    }

    const checked = event.target.checked;
    if (checked) {
      this.checkedItems = [...this.checkedItems, clickedItemValue];
    } else {
      this.checkedItems = this.checkedItems.filter(
        itemValue => itemValue !== clickedItemValue,
      );
    }

    this.onChange(this.checkedItems);
  }

  markAsTouched(): void {
    if (!this.touched) {
      this.touched = true;
      this.onTouched();
    }
  }

  writeValue(value: Array<string>): void {
    this.checkedItems = value;
  }

  registerOnChange(fn: (value: Array<string>) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabledState: boolean): void {
    this.disabled = disabledState;
  }
}
